import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.after('initialize', function() {
        this.on(this.$node, 'click', this.popupLink);
    });

    this.popupLink = function(e) {
        var w;
        var h;
        var dualScreenLeft;
        var dualScreenTop;
        var screenWidth;
        var screenHeight;
        var left;
        var top;
        var windowParams;
        var dimensionParams;

        e.preventDefault();

        w = this.$node.attr('data-popup-width') || 626; // What are these obscure numbers?
        h = this.$node.attr('data-popup-height') || 436;

        dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
        dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
        screenWidth = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
              ? document.documentElement.clientWidth
              : screen.width;
        screenHeight = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
              ? document.documentElement.clientHeight
              : screen.height;

        left = screenWidth / 2 - w / 2 + dualScreenLeft;
        top = screenHeight / 2 - h / 2 + dualScreenTop;

        windowParams =
            'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no';
        dimensionParams = 'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left;

        var newWindow = window.open(
            this.$node.attr('href'),
            '_blank',
            windowParams + ', ' + dimensionParams
        );
        newWindow.opener = null;

        if (window.focus) {
            newWindow.focus();
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/app/ui/popup-link.js